// src/components/StoreSettingsWizard/ShippingTab/index.jsx
import React, {useMemo} from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import ZoneCard from "./ZoneCard";
import { Toggle } from "../common/Toggle";
import countryList from "react-select-country-list";
import { MAX_ZONES } from "../constants/validation";

export default function ShippingTab() {
  const { control, trigger, watch } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "shippingGroups",
  });
    const allIso = useMemo(() => countryList().getData().map((c) => c.value), []);
  const groups = watch("shippingGroups") || [];
  const used = useMemo(() => {
    const s = new Set();
    groups.forEach((g) => (g.countries || []).forEach((c) => s.add(c)));
    return s;
  }, [groups]);
  const restOfWorld = useMemo(
    () => allIso.filter((iso) => !used.has(iso)),
    [allIso, used]
  );

   const addZone = () => {                                      // NEW
    if (fields.length >= MAX_ZONES) return;
    append({ name: "", countries: [], postalCodes: [], methods: [] });
     trigger("shippingGroups");                                 // NEW – re-validate right away
   };

  return (
    <section className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-medium">Shipping &amp; Delivery Zones</h2>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={addZone}
            disabled={fields.length >= MAX_ZONES}
            className={`rounded bg-green-600 px-4 py-1.5 text-sm text-white shadow
              ${fields.length >= MAX_ZONES ? "opacity-50" : "hover:bg-green-700"}`}
          >
            + Add Zone
          </button>
        </div>
      </div>

      {fields.length === 0 && (
        <p className="text-xs text-gray-500">No zones yet.</p>
      )}

      {fields.map((zone, idx) => (
        <ZoneCard
          key={zone.id}
          index={idx}
          onRemove={() => remove(idx)}
        />
      ))}
    </section>
  );
}
